import { AxiosResponse } from 'axios';

import BaseApi from './BaseApi';

class SettingsApi extends BaseApi {
	getGlobals(): Promise<AxiosResponse<unknown>> {
		return this.httpClient.get({ url: '/globals' });
	}
}

export const SettingsService = new SettingsApi();
